import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";

import NotifsContainer from "./Notifs/NotifsContainer";

import { setLanguage, setCurrentPortal /*, showSearchLayer*/ } from "Actions";
import { TTP_EMAILING_URL } from "Config";

import {
  getUserNameForAvatar,
  setCookie,
  setLocalStorageCookie,
  redirectToHome
} from "Utils";

import {
  TTP_API_URL,
  TTP_HOME_URL,
  TTP_PORTAL_URL,
  SOCIAL_NETWORKS_HOSTS,
  APP_ENV
} from "Config";
import _ from "i18n";

export class RightSide extends Component {
  logout(e) {
    //const { dispatch } = this.props;
    e.preventDefault();
    //dispatch(setAuth(null));
    setLocalStorageCookie(null);

    let dtExpire = new Date();
    dtExpire.setTime(dtExpire.getTime() - 3600000 * 1000);

    setCookie(`ttp_auth_${APP_ENV}`, "", dtExpire, "/", "tamtam.pro");
    setCookie(`ttp_session_${APP_ENV}`, "", dtExpire, "/", "tamtam.pro");
    setCookie("XSRF-TOKEN", "", dtExpire, "/", "tamtam.pro");
    setCookie("laravel_session", "", dtExpire, "/", "tamtam.pro");

    setTimeout(() => {
      redirectToHome();
    }, 200);
  }

  showSearchLayer(e) {
    // document.body.style.overflow = "hidden";
    // this.props.dispatch(showSearchLayer(true));
  }

  changeLng(e) {
    if (e.target.classList.contains("selected")) {
      return false;
    }
    const { dispatch } = this.props;
    dispatch(setLanguage(e.target.id));

    if (this.props.currentNavPage === "ARTICLE") {
      dispatch(push("/"));
    }

    window.location.reload();
  }

  renderContactSocialNetworkBlock(contactSocialNetworks, socialNetworkName) {
    if (!contactSocialNetworks) {
      return null;
    }

    let socialNetwork = contactSocialNetworks[socialNetworkName];

    if (socialNetwork) {
      let accessValue =
        socialNetworkName === "twitter"
          ? socialNetwork.username
          : socialNetwork.id;
      let snUrl =
        socialNetworkName === "linkedin"
          ? socialNetwork.publicProfileUrl
            ? socialNetwork.publicProfileUrl
            : ""
          : `${
              SOCIAL_NETWORKS_HOSTS[socialNetworkName.toUpperCase()]
            }/${accessValue}`;

      return (
        <li className="social">
          <a href={`${snUrl}`} target="_blank">
            <i className={`icon icon-social-${socialNetworkName}`} />
          </a>
        </li>
      );
    }

    return null;
  }

  changePortal(type, e) {
    if (e.currentTarget.classList.contains("activated")) {
      return false;
    }

    const { dispatch } = this.props;

    dispatch(setCurrentPortal(type));
  }

  render() {
    const {
      user,
      lng /*, loggedAsPost*/,
      routing,
      navCommunity,
      currentPortal
    } = this.props;

    let goto = `${TTP_HOME_URL}?goto=${encodeURI(
      TTP_PORTAL_URL + routing.location.pathname.substr(1)
    )}`;

    /*if (window.location.origin != TTP_PORTAL_URL) {
      goto = `${TTP_HOME_URL}?gotoWithAuth=${encodeURI(
        window.location.origin + routing.location.pathname.substr(1)
      )}`;
    }*/

    if (!user || !user.id) {
      return (
        <div className="top-bar-right menu__off">
          <div className="menu__language">
            <ul>
              <li
                id="fr"
                className={lng === "fr" ? "selected" : ""}
                onClick={this.changeLng.bind(this)}
              >
                FR
              </li>
              <li
                id="nl"
                className={lng === "nl" ? "selected" : ""}
                onClick={this.changeLng.bind(this)}
              >
                NL
              </li>
              <li
                id="en"
                className={lng === "en" ? "selected" : ""}
                onClick={this.changeLng.bind(this)}
              >
                EN
              </li>
            </ul>
          </div>
          <a className="sign-in" href={goto}>
            <i className="icon icon-lock" />
            {_("Sign in / Join")}
          </a>
        </div>
      );
    }

    const {
      avatar,
      avatarUrl,
      firstName,
      lastName,
      mainEmail,
      contactSocialNetworks
    } = user;

    //let portalConfig = null;
    let appsState = null;
    if (navCommunity && navCommunity.appsState) {
      appsState = navCommunity.appsState;
      //portalConfig = appsState.filter(app => app.code === "portal")[0];
    }

    let avatarDiv = null;
    if (avatar) {
      avatarDiv = (
        <div
          className="menu__img-wrap triangle"
          style={{
            backgroundImage: `url(${
              avatarUrl ? avatarUrl : TTP_API_URL + "/" + avatar
            })`
          }}
        />
      );
    } else {
      avatarDiv = (
        <div className="menu__img-wrap empty-avatar triangle">
          <span>{getUserNameForAvatar(firstName, lastName)}</span>
        </div>
      );
    }

    return (
      <div className="top-bar-right">
        {/*<div id="portal-switcher">
          <span
            className={`left-switch ${
              currentPortal === "COMMUNITY" ? "activated" : "desactivated"
            }`}
            onClick={this.changePortal.bind(this, "COMMUNITY")}
          >
            {_("Community")}
          </span>
          <img alt="" src="/img/icons/portal2.svg" className="PORTAL" />
          <span
            className={`right-switch ${
              currentPortal === "WORK" ? "activated" : "desactivated"
            }`}
            onClick={this.changePortal.bind(this, "WORK")}
          >
            {_("Work place")}
          </span>
          </div>*/}
        <ul className="menu buttons notifications">
          {/*portalConfig && portalConfig.activated ? (
            <li className="social-links">
              <a href={portalConfig.url}>
                <img alt="" src="/img/icons/portal.svg" className="PORTAL" />
              </a>
            </li>
          ) : null*/}

          <li className="social-links">
            <a href={`${TTP_HOME_URL}/landing`}>
              <img alt="" src="/img/icons/profile.svg" className="PROFILE" />
            </a>
          </li>
          <li className="social-links ebox">
            <a href={`${TTP_EMAILING_URL}/e_box`}>
              <img alt="" src="/img/icons/ebox.svg" className="EBOX" />
            </a>
          </li>
          <NotifsContainer />
          {appsState ? (
            <li className="social-links expandable apps">
              <a className="triangle">
                <img alt="" src="/img/icons/apps.svg" className="APPS" />
              </a>
              <div className="social-links__wrapper">
                <div className="social-links__header">
                  {_("TAMTAM Applications")}
                </div>
                <div className="social-links__body">
                  <ul className="small-up-3 grid-x">
                    {appsState.filter(app => app.code !== "portal").map(app => {
                      return (
                        <li key={app.name[lng]} className="cell small-4">
                          {app.activated ? (
                            <a className={`app-wrapper enabled`} href={app.url}>
                              <img alt="" src={app.icon} />
                              <div className="app-name">{app.name[lng]}</div>
                            </a>
                          ) : (
                            <span className={`app-wrapper disabled`}>
                              <img alt="" src={app.icon} />
                              <div className="app-name">{app.name[lng]}</div>
                            </span>
                          )}
                        </li>
                      );
                    })}
                    {/*appsState.map(app => {
                    return Object.keys(app).map((key, index) => {
                      const nameAttr = `name${lng.charAt(0).toUpperCase() +
                        lng.slice(1)}`;
                      return (
                        <li className="cell small-4">
                          <a
                            className={`app-wrapper${
                              parseInt(app[key].activated, 10) === 0
                                ? " disabled"
                                : " enabled"
                            }`}
                            href={app[key].url}
                          >
                            <img alt="" src={app[key].icon} />
                            <div className="app-name">{app[key][nameAttr]}</div>
                          </a>
                        </li>
                      );
                    });
                  })*/}
                  </ul>
                </div>
              </div>
            </li>
          ) : null}
        </ul>
        <ul className="menu">
          <li className="expandable menu__img profile social-links">
            {avatarDiv}
            <div className="social-links__wrapper">
              <div className="flex-container social-links__header">
                {avatarDiv}
                <div className="flex-container flex-dir-column infos">
                  <span>{firstName + " " + lastName}</span>
                  {!mainEmail ? null : (
                    <span className="email">{mainEmail}</span>
                  )}
                </div>
              </div>
              <div className="social-links__body">
                <ul className="sub-menu__dropdown">
                  <li className="menu__language">
                    <ul>
                      <li
                        id="fr"
                        className={lng === "fr" ? "selected" : ""}
                        onClick={this.changeLng.bind(this)}
                      >
                        FR
                      </li>
                      <li
                        id="nl"
                        className={lng === "nl" ? "selected" : ""}
                        onClick={this.changeLng.bind(this)}
                      >
                        NL
                      </li>
                      <li
                        id="en"
                        className={lng === "en" ? "selected" : ""}
                        onClick={this.changeLng.bind(this)}
                      >
                        EN
                      </li>
                    </ul>
                  </li>
                  <li className="menu__social">
                    <ul>
                      {this.renderContactSocialNetworkBlock(
                        contactSocialNetworks,
                        "facebook"
                      )}
                      {this.renderContactSocialNetworkBlock(
                        contactSocialNetworks,
                        "twitter"
                      )}
                      {this.renderContactSocialNetworkBlock(
                        contactSocialNetworks,
                        "linkedin"
                      )}
                    </ul>
                  </li>
                </ul>
              </div>
              <div
                className="social-links__footer logout"
                onClick={this.logout.bind(this)}
              >
                <Link className="text-center" to="/">
                  {_("logout")}
                </Link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  user: state.auth.user,
  loggedAs: state.auth.loggedAs,
  currentPortal: state.auth.currentPortal,
  //loggedAsPost: state.auth.loggedAsPost,
  lng: state.params.lng,
  currentNavPage: state.params.currentNavPage,
  routing: state.routing,
  navCommunity: state.auth.navCommunity
});

export default connect(mapStateToProps)(RightSide);



// WEBPACK FOOTER //
// ./src/components/Menu/RightSide.js